import NoData from "@/components/client/NoData";
import { MatchLabel } from "@/components/server/Match";
import LiveEvents from "@/components/client/LiveEvents"
import { isNextBuild } from "@/lib/target";

export default function MatchEvents({match}) {
  
  if (!match) {
    return (<NoData/>);
  }

  return (
    <>  
    <div>
      <MatchLabel label={'Diễn biến chính'}/>
      <div className="rounded overflow-hidden">
          {isNextBuild && (
            <iframe 
            src={`https://www.isportslive8.com/football/detail.html?matchId=${match.id}&accessKey=PTJkehrxASq3ngRywjR4rWm71eNRynFg&statsPanel=hide&lang=vi`} 
            width="100%" 
            className="h-72 @lg:h-650"
            frameBorder="0"></iframe>
          )}
          <LiveEvents matchId={match.id} />
      </div>
    </div>
    </>
  );
}